import './style.css';
import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/WebGLTile.js';
import View from 'ol/View.js';
import XYZ from 'ol/source/XYZ.js';
import {getRenderPixel} from 'ol/render.js';
import LayerGroup from 'ol/layer/Group.js';
import ImageTile from 'ol/source/ImageTile.js';
import {Attribution, defaults as defaultControls} from 'ol/control.js';
import {fromLonLat} from 'ol/proj';

const vizmethod = document.getElementById('vizmethod');
const baseMap = document.getElementById('baseMap');
const mapLeft = document.getElementById('mapLeft');
const mapRight = document.getElementById('mapRight');
const swipe = document.getElementById('swipe');

const attribution = new Attribution({
	collapsible: false,
	attributions: 'Ferenci Tamás, <a href="https://www.tura-mult.hu">tura-mult.hu</a>. Az OSZK Térkép-, Plakát és Kisnyomtatványtára engedélyével; minden további nyilvános felhasználás az OSZK engedélyéhez kötött. A Kartográfiai Vállalat térképei a Cartographia Kft. engedélyével.'
});
const attributionL = new Attribution({
	collapsible: false,
	attributions: 'Ferenci Tamás, <a href="https://www.tura-mult.hu">tura-mult.hu</a>. Az OSZK Térkép-, Plakát és Kisnyomtatványtára engedélyével; minden további nyilvános felhasználás az OSZK engedélyéhez kötött. A Kartográfiai Vállalat térképei a Cartographia Kft. engedélyével.'
});
const attributionR = new Attribution({
	collapsible: false,
	attributions: 'Ferenci Tamás, <a href="https://www.tura-mult.hu">tura-mult.hu</a>. Az OSZK Térkép-, Plakát és Kisnyomtatványtára engedélyével; minden további nyilvános felhasználás az OSZK engedélyéhez kötött. A Kartográfiai Vállalat térképei a Cartographia Kft. engedélyével.'
});

function mapprerender(event, left) {
	const gl = event.context;	
	gl.enable(gl.SCISSOR_TEST);	

	const mapSize = map.getSize();

	const bottomLeft = getRenderPixel(event, [0, mapSize[1]]);
	const topRight = getRenderPixel(event, [mapSize[0], 0]);
	
	const width = Math.round((topRight[0] - bottomLeft[0]) * (swipe.value / 100));
	const height = topRight[1] - bottomLeft[1];
	
	if (left == true) {
		gl.scissor(bottomLeft[0], bottomLeft[1], width, height);
	} else {
		gl.scissor(width, bottomLeft[1], topRight[0], height);
	}	
}

function mapprerenderL(event) {
	mapprerender(event, true);
}
function mapprerenderR(event) {
	mapprerender(event, false);
}

function mappostrender(event) {
	const gl = event.context;
	gl.disable(gl.SCISSOR_TEST);	
}

const osm = new TileLayer({source: new OSM()});
const osmLeft = new TileLayer({source: new OSM()});
const osmRight = new TileLayer({source: new OSM()});
const cartographia = new TileLayer({source: new ImageTile({
        url:'https://tile.cartographia.hu/outdoor/{z}/{x}/{y}.png'
	})
})
const cartographiaLeft = new TileLayer({source: new ImageTile({
        url:'https://tile.cartographia.hu/outdoor/{z}/{x}/{y}.png'
	})
})
const cartographiaRight = new TileLayer({source: new ImageTile({
        url:'https://tile.cartographia.hu/outdoor/{z}/{x}/{y}.png'
	})
})

const srcLeft = new TileLayer();
const srcRight = new TileLayer();

function updateMap(src, map, vizmethod, prerender, postrender, opacity) {
	src.setSource(new XYZ({url: 'https://terkep.tura-mult.hu/' + map + '/{z}/{x}/{-y}.png',
                           tileSize: [256, 256]}) );
	if(vizmethod == 'vertsep') {
		src.on('prerender', prerender);
		src.on('postrender', postrender);
		src.setOpacity(1);
	} else if(vizmethod == 'opacity') {
		src.un('prerender', prerender);
		src.un('postrender', postrender);
		src.setOpacity(opacity);
	} else if(vizmethod == 'syncmaps') {
		src.un('prerender', prerender);
		src.un('postrender', postrender);
		src.setOpacity(1);
	}
}

const view = new View({
	center: [centers.centerx, centers.centery],
	zoom: 12,
})

const map = new Map({
	layers: [],
	controls: defaultControls({attribution: false}).extend([attribution]),
	target: 'map',
	view: view
});

const mapSyncLeft = new Map({
	layers: [],
	controls: defaultControls({attribution: false}).extend([attributionL]),
	target: 'mapSyncLeft',
	view: view
});

const mapSyncRight = new Map({
	layers: [],
	controls: defaultControls({attribution: false}).extend([attributionR]),
	target: 'mapSyncRight',
	view: view
});

function checkSize() {
  const small = map.getSize()[0] < 600;
  attribution.setCollapsible(small);
  attribution.setCollapsed(small);
}
map.on('change:size', checkSize);
checkSize();

function checkSizeL() {
  const small = mapSyncLeft.getSize()[0] < 600;
  attributionL.setCollapsible(small);
  attributionL.setCollapsed(small);
}
mapSyncLeft.on('change:size', checkSizeL);
checkSizeL();

function checkSizeR() {
  const small = mapSyncRight.getSize()[0] < 600;
  attributionR.setCollapsible(small);
  attributionR.setCollapsed(small);
}
mapSyncRight.on('change:size', checkSizeR);
checkSizeR();

swipe.addEventListener('input', function () {
	if(vizmethod.value == 'opacity') {
		srcLeft.setOpacity(1-swipe.value/100);
		srcRight.setOpacity(swipe.value/100);
	}
	map.render();
});

function update() {
	if(vizmethod.value != 'syncmaps') {
		map.setLayerGroup(new LayerGroup());
	} else {
		mapSyncLeft.setLayerGroup(new LayerGroup());
		mapSyncRight.setLayerGroup(new LayerGroup());
	}
	
	if(baseMap.value != 'none') {
		if(vizmethod.value != 'syncmaps') {
			if(baseMap.value == 'osm') {
				map.addLayer(osm);
			} else {
				map.addLayer(cartographia);
			}
		} else {
			if(baseMap.value == 'osm') {
				mapSyncLeft.addLayer(osmLeft);
				mapSyncRight.addLayer(osmRight);
			} else {
				mapSyncLeft.addLayer(cartographiaLeft);
				mapSyncRight.addLayer(cartographiaRight);
			}			
		}
	}
	if(mapLeft.value != 'None') {
		updateMap(srcLeft, mapLeft.value, vizmethod.value, mapprerenderL, mappostrender, 1-swipe.value/100);
		if(vizmethod.value != 'syncmaps') {		
			map.addLayer(srcLeft);
		} else {			
			mapSyncLeft.addLayer(srcLeft);
		}
	}
	if(mapRight.value != 'None') {
		updateMap(srcRight, mapRight.value, vizmethod.value, mapprerenderR, mappostrender, swipe.value/100);
		if(vizmethod.value != 'syncmaps') {			
			map.addLayer(srcRight);
		} else {			
			mapSyncRight.addLayer(srcRight);
		}
	}
}

vizmethod.addEventListener('change', update);
baseMap.addEventListener('change', update);
mapLeft.addEventListener('change', update);
mapRight.addEventListener('change', update);

update();